import React, { useEffect, useState, useCallback } from "react";
import { ASSETS } from "@/lib/links";

const PAUSE_MS = 3500;

export default function GiveawayFeedbackCarousel({
  images = ASSETS.giveawayFeedback,
}) {
  const slides = images.filter(Boolean);
  const [index, setIndex] = useState(0);

  const next = useCallback(() => {
    setIndex((i) => (i + 1) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const id = window.setInterval(next, PAUSE_MS);
    return () => window.clearInterval(id);
  }, [next, slides.length]);

  if (slides.length === 0) return null;

  const current = slides[index];

  return (
    <section id="giveaway-feedback" className="relative z-10 py-8 sm:py-10">
      <div className="max-w-2xl mx-auto px-4">
        <div className="mb-4 text-center">
          <span className="game-tag">Winner Proof</span>
          <h2 className="font-display text-base sm:text-xl font-bold text-white mt-2">
            Orang betul menang
          </h2>
          <p className="text-[#8B9CC7] text-xs sm:text-sm mt-1">
            Feedback winner dari giveaway lepas
          </p>
        </div>

        <div className="giveaway-carousel-frame">
          <img
            src={current}
            alt={`Giveaway winner feedback ${index + 1}`}
            className="giveaway-carousel-img"
            draggable={false}
            loading="lazy"
            decoding="async"
          />

          {slides.length > 1 ? (
            <div className="giveaway-carousel-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  aria-label={`Slide ${i + 1}`}
                  className={`giveaway-carousel-dot ${i === index ? "is-active" : ""}`}
                  onClick={() => setIndex(i)}
                />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
